import React from 'react';
type BookCoverProps = {
  kicker: string;
  title: string;
  number?: string;
  accent?: string;
  size?: 'sm' | 'md';
  className?: string;
};

/**
 * Code-drawn product cover (Baseline Navy + Ball Lime). Stands in for rendered
 * mockups until the real Court Ready covers are uploaded.
 */
export function BookCover({
  kicker,
  title,
  number,
  accent = 'bg-gold',
  size = 'md',
  className = ''
}: BookCoverProps) {
  const sm = size === 'sm';
  return <div className={`relative aspect-[2/3] overflow-hidden rounded-[6px] border border-white/10 bg-gradient-to-br from-navy-mid via-navy to-navy-deep shadow-book ${className}`} data-id="element-38" data-mp="2o7rho77x805g">
      <span className={`absolute inset-y-0 left-0 w-[7%] ${accent}`} aria-hidden="true" data-id="element-39" data-mp="2eg50lu8wj6us" />
      <span className="absolute -right-6 -top-6 h-20 w-20 rounded-full bg-gold/10 blur-2xl" aria-hidden="true" data-id="element-40" data-mp="29exoxk3n1niu" />
      <div className="relative flex h-full flex-col justify-between py-[11%] pl-[16%] pr-[10%]" data-id="element-41" data-mp="20fkgmur934zp">
        <div data-id="element-42" data-mp="19a98llulhz92">
          <p className={`font-bold uppercase tracking-[0.18em] text-gold ${sm ? 'text-[5.5px] sm:text-[7.5px]' : 'text-[9px]'}`} data-id="element-43" data-mp="199q1z1aeaxac">
            {kicker}
          </p>
          {number && <p className={`mt-1 font-display font-bold leading-none text-white/15 ${sm ? 'text-2xl sm:text-4xl' : 'text-5xl'}`} data-id="element-44" data-mp="zaif9nhrtqak">
              {number}
            </p>}
        </div>
        <p className={`font-display font-bold uppercase leading-[0.95] text-white ${sm ? 'text-[9px] sm:text-[14px]' : 'text-[19px]'}`} data-id="element-45" data-mp="1x0lr1qngvedw">
          {title}
        </p>
        <div className="flex items-center gap-1.5" data-id="element-46" data-mp="1n14o3gzlnelm">
          <span className="h-px flex-1 bg-gold/50" data-id="element-47" data-mp="7lf9g3a8k7vt" />
          <span className={`whitespace-nowrap font-bold uppercase tracking-widest text-white/55 ${sm ? 'text-[4.5px] sm:text-[6.5px]' : 'text-[8px]'}`} data-id="element-48" data-mp="7kmc1sx62uqc">
            Court Ready
          </span>
        </div>
      </div>
    </div>;
}